import { motion } from "framer-motion";
import { makeStyles } from "@material-ui/core";
import { Input, Button, TextField, TextareaAutosize } from "@material-ui/core";
// import "./Test.css";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),

    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px"
    },
    "& .MuiFormLabel-root": {
      color: "#eddbca", // or black
      outline: "red",
      fontSize: "13px",
      input: {
        color: "white"
      }
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2)
    },
    "& .MuiInputBase-root": {
      color: "#eddbca",
      fontSize: "14px"
    },
    input: {
      backgroundColor: "white",
      color: "white"
    },
    TextField: {
      color: "white"
    }
  }
}));
const SignUp = ({ formData, setFormData, page, setPage, x, setX }) => {
  const classes = useStyles();
  const handleSubmit = () => {};
  return (
    <motion.div
      initial={{ x: x }}
      animate={{ x: 0 }}
      transition={{ duration: 1 }}
      className="card"
    >
      {/* <TextField
          label="Email"
         "
          type="email"
          name="email"
          required
          value={data.email}
          onChange={handleChange}
        /> */}
      <form className={classes.root} onSubmit={handleSubmit}>
        <h3 style={{ marginTop: 20, color: "white" }}>
          ✍🏽 Welcome to A2SV registration
        </h3>
        <div className="underline"></div>
        <h4 style={{ marginTop: 10, color: "white" }}>
          👉🏽 About Yourself - 1/5❗️
        </h4>

        <TextField
          type="text"
          placeholder="Full Name"
          variant="outlined"
          className="form-group"
          value={formData.name}
          required
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
        {/* <TextField
  placeholder="MultiLine with rows: 2 and rowsMax: 4"
  multiline
  rows={2}
  maxRows={4}
/> */}
        <TextareaAutosize
          aria-label="minimum height"
          minRows={6}
          placeholder="Tell your short bio"
          variant="outlined"
          className="textareaforbio"
          value={formData.shortBio}
          onChange={(e) =>
            setFormData({ ...formData, shortBio: e.target.value })
          }
          style={{ width: 297, background: "transparent", color: "white" }}
        />
        {/* <TextField
          type="text"
          className="form-group"
          placeholder="Username"
          variant="outlined"
          value={formData.shortBio}
          onChange={(e) =>
            setFormData({ ...formData, shortBio: e.target.value })
          }
        /> */}
      </form>
      <Button
        variant="contained"
        color="primary"
        style={{ marginBottom: 10 }}
        onClick={() => {
          setPage(page + 1);
          setX(1000);
        }}
      >
        Next
      </Button>
    </motion.div>
  );
};

export default SignUp;
